import { FILE_CONFIG } from '@/constants/file.constants';

interface FileValidationResult {
  isValid: boolean;
  error?: string;
}

export const validateFile = (file: File): FileValidationResult => {
  // Проверка размера
  if (file.size > FILE_CONFIG.UPLOAD.MAX_SIZE) {
    return {
      isValid: false,
      error: FILE_CONFIG.UPLOAD.ERROR_MESSAGES.SIZE
    };
  }

  // Проверка типа файла
  const fileExtension = `.${file.name.split('.').pop()?.toLowerCase()}`;
  if (!FILE_CONFIG.UPLOAD.EXTENSIONS.includes(fileExtension as any)) {
    return {
      isValid: false,
      error: FILE_CONFIG.UPLOAD.ERROR_MESSAGES.TYPE
    };
  }

  return { isValid: true };
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};

export const getFileExtension = (filename: string): string => {
  return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2);
};

export const isImageFile = (type: string): boolean => {
  return type.startsWith('image/');
};

export const getFileIcon = (type: string): string => {
  // Здесь можно добавить логику для определения иконки файла
  // в зависимости от его типа
  if (isImageFile(type)) return 'image';
  if (type.includes('pdf')) return 'pdf';
  if (type.includes('word')) return 'word';
  return 'file';
};
